import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function TimerStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M20.25 13C20.25 8.44365 16.5563 4.75 12 4.75C7.44365 4.75 3.75 8.44365 3.75 13C3.75 17.5563 7.44365 21.25 12 21.25C16.5563 21.25 20.25 17.5563 20.25 13ZM21.75 13C21.75 18.3848 17.3848 22.75 12 22.75C6.61522 22.75 2.25 18.3848 2.25 13C2.25 7.61522 6.61522 3.25 12 3.25C17.3848 3.25 21.75 7.61522 21.75 13Z"
				fill="currentColor"
			/>
			<path
				d="M4.37598 4.36821C4.60574 4.02356 5.07137 3.93044 5.41602 4.1602L6.91602 5.1602C7.26066 5.38996 7.35379 5.85559 7.12402 6.20024C6.89426 6.54489 6.42863 6.63801 6.08398 6.40825L4.58398 5.40825C4.23934 5.17848 4.14621 4.71285 4.37598 4.36821ZM18.584 4.1602C18.9286 3.93044 19.3943 4.02356 19.624 4.36821C19.8538 4.71285 19.7607 5.17848 19.416 5.40825L17.916 6.40825C17.5714 6.63801 17.1057 6.54489 16.876 6.20024C16.6462 5.85559 16.7393 5.38996 17.084 5.1602L18.584 4.1602Z"
				fill="currentColor"
			/>
			<path
				d="M11.25 4V2.75H9.5C9.08579 2.75 8.75 2.41421 8.75 2C8.75 1.58579 9.08579 1.25 9.5 1.25H14.5C14.9142 1.25 15.25 1.58579 15.25 2C15.25 2.41421 14.9142 2.75 14.5 2.75H12.75V4C12.75 4.41421 12.4142 4.75 12 4.75C11.5858 4.75 11.25 4.41421 11.25 4Z"
				fill="currentColor"
			/>
			<path
				d="M12.5304 12.4713C12.4205 12.3614 12.2857 12.293 12.1437 12.2655L12 12.2517C11.8069 12.2518 11.6163 12.3247 11.4697 12.4713C11.1768 12.7642 11.1768 13.2391 11.4697 13.5319C11.7626 13.8248 12.2375 13.8248 12.5304 13.5319C12.8233 13.2391 12.8233 12.7642 12.5304 12.4713ZM13.591 11.4106C14.4697 12.2893 14.4697 13.7139 13.591 14.5926C12.7124 15.4713 11.2877 15.4713 10.4091 14.5926C9.5304 13.7139 9.5304 12.2893 10.4091 11.4106C10.6541 11.1655 10.9429 10.9907 11.2494 10.8824L11.2501 7.34476C11.2501 6.93054 11.5858 6.59484 12 6.59484C12.4143 6.59484 12.75 6.93054 12.75 7.34476L12.7493 10.8824C13.0563 10.9907 13.3456 11.1652 13.591 11.4106Z"
				fill="currentColor"
			/>
		</svg>
	);
}

TimerStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default TimerStrokeIcon;
